var _g, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuffleHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 40",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.05,17.636,22.636,19.05,26.586,23H22.472a2.986,2.986,0,0,1-2.683-1.658L17.118,16l2.671-5.342A2.986,2.986,0,0,1,22.472,9h4.114l-3.95,3.95,1.414,1.414,5.657-5.657a1,1,0,0,0,0-1.414L24.05,1.636,22.636,3.05,26.586,7H22.472A4.974,4.974,0,0,0,18,9.764l-2,4-2-4A4.974,4.974,0,0,0,9.528,7H2V9H9.528a2.986,2.986,0,0,1,2.683,1.658L14.882,16l-2.671,5.342A2.986,2.986,0,0,1,9.528,23H2v2H9.528A4.974,4.974,0,0,0,14,22.236l2-4,2,4A4.974,4.974,0,0,0,22.472,25h4.114l-3.95,3.95,1.414,1.414,5.657-5.657a1,1,0,0,0,0-1.414Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 47,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Komkrit Noenpoempisut")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 52,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffleHero);
export default __webpack_public_path__ + "static/media/shuffle-hero.3db34679597569b4e6b9cc7a70aa623d.svg";
export { ForwardRef as ReactComponent };